import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { CustomChatOpenRequest, CustomChatState } from '../types';

const initialState: CustomChatState = {
  activeChannelId: null,
  pendingOpenChatRequest: null,
  unreadMessages: {
    count: 0,
  },
};

export const customChatSlice = createSlice({
  initialState,
  name: 'custom-chat',
  reducers: {
    clearCustomChatOpenRequest(state) {
      state.pendingOpenChatRequest = null;
    },
    requestOpenCustomChat(
      state,
      { payload }: PayloadAction<CustomChatOpenRequest>
    ) {
      state.pendingOpenChatRequest = payload;
    },
    setCustomChatActiveChannelId(
      state,
      { payload }: PayloadAction<number | string | null>
    ) {
      state.activeChannelId = payload;
    },
    updateCustomChatUnreadMessages(
      state,
      { payload }: PayloadAction<{ unreadCount: number }>
    ) {
      state.unreadMessages.count = payload.unreadCount;
    },
  },
});

export const {
  clearCustomChatOpenRequest,
  requestOpenCustomChat,
  setCustomChatActiveChannelId,
  updateCustomChatUnreadMessages,
} = customChatSlice.actions;

export default customChatSlice.reducer;

